import React from 'react';
import get from 'lodash/get';

import BackgroundView from './BackgroundView.react';
import ContentView from './ContentView.react';
import Browser from '../util/Browser';
import MoatDebug from '../util/Moat';

class EngagementApp extends React.Component {
  state = {
    open: false,
    iframePixelsFired: false,
    didFinishShowCalled: false,
  };

  componentWillMount() {
    const payload = Browser.getParameterValue('payload');
    if (!Browser.isMobile() || payload) {
      window.prepareToShow();
    }
    this.updateComponentDimensions();
    this.doLoad();
  }

  componentDidMount() {
    const payload = Browser.getParameterValue('payload');
    if (!Browser.isMobile() || payload) {
      window.show();
    }
  }

  componentWillUnmount() {
    window.removeEventListener('resize', this.updateComponentDimensions);
  }

  isReadyToOpen = () => {
    console.log('isReadyToOpen(), Ready to open');
    return this.setState({ open: true }, this.didFinishShow);
  };

  doLoad = () => {
    console.log('Doing load', 'doLoad()');
    this.iframeError = this.iframeError || false;

    // logging to server
    window.server.logForImprIds('EngagementApp_mounted');

    window.addEventListener('message', this.postMessageReceiver);
    window.addEventListener('resize', this.updateComponentDimensions);
    this.updateComponentDimensions();

    if (this.props.on) {
      this.props.on('app_opened', () => {
        console.log('App is opened, setting open to true and calling didFinishShow');
        return this.setState({ open: true }, this.didFinishShow);
      });
    }
  };

  didFinishShow = () => {
    // must have a condition on unhandled m2m://interstitial urls for ios,
    // as ios will not cancel the request loading the same way android does.
    if (!Browser.isIOS()) {
      // voodoo below... without this dummy call, the e2 app dies a horrible
      // death in android.  there must be an m2m://interstitial href at this
      // point elsewise all pending requests end up canceled and the e2 app
      // displays empty on the screen.  not sure why yet.
      // deferring didFinishShow is so that moatad.js can be loaded prior to the
      // om impression event triggered from the android/ios layer
      window.server.notifySdk('ignoreThis');
    }

    // if the iframe pixels have already fired, and we haven't called it yet,
    // then do so now
    if (this.state.iframePixelsFired && !this.state.didFinishShowCalled) {
      this.props.didFinishShow();
      this.setState({ didFinishShowCalled: true });
    }

    // this is called on app_open, so if we don't get the pels fired
    // in 500ms, then go ahead and call finish show so we don't miss
    // an opportunity
    setTimeout(() => {
      if (!this.state.didFinishShowCalled) {
        console.warn('EngagementApp - calling didFinishShow in timeout');
        this.props.didFinishShow();
        this.setState({ didFinishShowCalled: true });
      }
    }, 500);
  };

  didFinishLoad = (event, iframeError) => {
    if (iframeError) {
      this.handleIframeError(event);
    }

    this.props.didFinishLoad();
  };

  /*
    Prevent E2 from opening if Card iframe load error during preload.
  */
  handleIframeError = event => {
    console.log('engagementApp.handleIframeError - error loading iframe card.');
    this.iframeError = true;
    this.setState({ open: false });
    window.bugsnagClient.notify(new Error('handleIframeError error loading iframe card'));
    window.server.notifySdk('didFinishLoadWithError?message=Could not load ad');
    return true;
  };

  updateComponentDimensions = () => {
    const screenWidth = Math.max(document.documentElement.clientWidth, window.innerWidth || 0);
    const screenHeight = Math.max(document.documentElement.clientHeight, window.innerHeight || 0);
    console.log(`resize, new screenWidth: ${screenWidth}, screenHeight: ${screenHeight}`);
    this.setState({ screenWidth, screenHeight });
  };

  doClose = () => {
    this.setState({ open: false });
  };

  postMessageReceiver = event => {
    if (typeof event.data !== 'string' || event.data.indexOf('react-devtools') !== -1) {
      return;
    }

    console.warn('EngagementApp - MessageEvent: ', event);

    try {
      const data = JSON.parse(event.data);
      if (!data.action || !data.m2m_impr_id) {
        return;
      }

      if (get(data, 'action', '') === 'close_e2') {
        // Close e2. Sent from surveygizmo
        this.doClose();
      }

      if (data.action === 'iframe_pixels_fired') {
        console.log('Found iframe_pixels_fired');

        const toState = { iframePixelsFired: true };

        // if the app is open and we receive this event,
        // then that means third_party_impr_pels.js has fired
        // it's pixels and we can go ahead and notify the
        // sdk that we're showing the ad.
        if (this.state.open && !this.state.didFinishShowCalled) {
          this.props.didFinishShow();
          toState.didFinishShowCalled = true;
        }

        this.setState(toState);
      }
    } catch (e) {}
  };

  render() {
    return (
      <div>
        <MoatDebug ad={get(this.props, 'payload.data.actions[0].ads[0]', {})} />
        <BackgroundView />
        <ContentView
          isReadyToOpen={this.isReadyToOpen}
          doClose={this.doClose}
          width={this.state.screenWidth}
          height={this.state.screenHeight}
          didFinishHide={this.props.didFinishHide}
          didFinishLoad={this.didFinishLoad}
          actions={get(this.props.payload, 'data.actions', [])}
          fields={get(this.props.payload, 'data.fields', {})}
          open={this.state.open}
        />
      </div>
    );
  }
}

export default EngagementApp;
